export default {
  SYSTEM_CODE: 'ARCHWAY',
  DEBUG: false,
  // Configuration for the vitamins system tracker
  VITAMINS: {
    KEY: 'vitamins_logs',
    STORAGE: 10,
    MSG_NAV: 'nav',
    MSG_PUBSUB: 'pubsub',
    MSG_STORE: 'store',
  },
  // General API client configurations
  API: {
    URI: '/api',
    TIMEOUT: 45000,
  },
  AUTHENTICATION: {
    MODE: 'AUTH0',
    CALLBACK_URL: `https://${window.location.host}/callback`,
  },
  QRS: {
    GatewayURL: '',
    PowerBIReportsUrl: '',
  },
  LOCATION: {
    locationUrl: '',
  },
  VINTA: {
    BASE_URL: '',
  },
  FILER_MAILBOX_ADDRESS: '',
  FLAGS: {},
  FEATURES: {},
};
